import { CardsScreen } from '../features/account/CardsScreen'

export function ProfileCardsPage() {
  return <CardsScreen />
}
